import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import { priorityLabel, STATUS_ICONS, statusLabel, ticketAssignees, ticketGuest } from '../../common/utils/tickets';
/**
 * Status, priority and assignees pills of a ticket.
 */
export default class TicketLabels extends Component {
  view() {
    const discussion = this.attrs.discussion;
    const status = discussion.ticketStatus();
    const priority = discussion.ticketPriority();
    const assignees = ticketAssignees(discussion);
    const guest = ticketGuest(discussion);
    return m("span", {
      className: "TicketLabels"
    }, m("span", {
      className: classList('TicketLabel', 'TicketLabel--status', `TicketLabel--${status}`)
    }, m(Icon, {
      name: STATUS_ICONS[status] || 'fas fa-ticket'
    }), " ", statusLabel(status)), priority && priority !== 'normal' && m("span", {
      className: classList('TicketLabel', 'TicketLabel--priority', `TicketLabel--${priority}`)
    }, priorityLabel(priority)), guest && m("span", {
      className: "TicketLabel TicketLabel--guest",
      title: guest.email
    }, m(Icon, {
      name: "fas fa-envelope"
    }), " ", app.translator.trans('soup-97-support.forum.ticket.guest_label'), ": ", guest.name), this.attrs.showAssignee && assignees.length > 0 && m("span", {
      className: "TicketLabel TicketLabel--assignee"
    }, m(Icon, {
      name: "fas fa-user-tag"
    }), " ", assignees.map(user => user.displayName()).join(', ')));
  }
}
flarum.reg.add('soup-97-support', 'forum/components/TicketLabels', TicketLabels);